export enum RoleEnum {
  admin = 'admin',
  contentManager = 'content_manager',
  moderator = 'moderator',
  observer = 'observer',
  companyContentManager = 'company_content_manager',
}

export interface DraftUser {
  email: string;
  password: string;
  role: RoleEnum;
}

export interface User {
  id: number;
  email: string;
  username: string;
  blocked: boolean;
  role: RoleEnum;
  admin: boolean;
  password?: string;
}
